import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { DataService_BellScheduleSetup } from "../data.service";
import { AddPeriodComponent } from "./add-period/add-period.component";

@Component({
	selector: "caass-bell-schedule-periods",
	templateUrl: "./bell-schedule-periods.component.html",
	styleUrls: ["./bell-schedule-periods.component.css"],
})
export class BellSchedulePeriodsComponent implements OnInit {
	constructor(private userService: UserService, private BellScheduleSetupService: DataService_BellScheduleSetup, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.lstPeriod = [];

		if (this.BellScheduleID != undefined) {
			this.loadBellScheduleDetails();
		}
	}

	ngOnChanges() {
		if (this.BellScheduleID != undefined) {
			this.loadBellScheduleDetails();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	@Output() ListChanged: EventEmitter<any> = new EventEmitter();

	@Input() EditMode: any = false;
	@Input() BellScheduleID: any;

	@Input() SchoolID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPeriods: any = [];
	lstPeriod: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PeriodNo", header: "Period Number" },
		{ field: "PeriodDesc", header: "Description" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadBellScheduleDetails() {
		var result = this.BellScheduleSetupService.LoadBellScheduleDetails(this.BellScheduleID);
		result.subscribe(
			(response) => {
				this.lstPeriod = response;

				for (var i = 0; i < this.lstPeriod.length; i++) {
					var next = this.lstPeriod[i];

					next.StartTimeDate = new Date(next.StartTime);
					next.EndTimeDate = new Date(next.EndTime);
					next.TardyTimeDate = new Date(next.TardyTime);
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onAdd() {
		var ref = this.dialogService.open(AddPeriodComponent, {
			header: "Add Periods",
			width: "fit-content",
			data: {
				SelectedPeriods: this.lstPeriod,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.lstPeriod = response;

				this.SelectedPeriods = [];

				this.UpdateList();
			}
		});
	}

	onRemove() {
		this.lstPeriod = this.lstPeriod.filter((period) => this.SelectedPeriods.indexOf(period) == -1);
		this.SelectedPeriods = [];

		this.UpdateList();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}

	UpdateList() {
		this.ListChanged.emit(this.lstPeriod);
	}
	////////////////////////////////////////////
}
